import React, { useContext, useState, useEffect } from 'react';
import { Button, Col, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, Row, InputGroup, InputGroupText, Card, CardBody } from 'reactstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import InputMask from 'react-input-mask';
import useAxios from 'hooks/useAxios';
import { AppContext } from 'context';
import Loader from 'components/Loader';
import Confirm from 'components/Confirm';
import PatientList from 'components/PatientList';
import NPIProviderList from 'components/NPIProviderList';
import { Formik, Field, Form } from 'formik';
import Calendar from 'assets/icon/calendar-icon.svg';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { dateFormate } from 'utils/columns';
import { hasSelectionSupport } from '@testing-library/user-event/dist/utils';
import SmartApproval from 'components/SmartApproval';
import save from "assets/icon/save.svg";
import deleteicon from "assets/icon/Icons (48).svg";
import MapiconWhite from "assets/icon/MapIcon-White.svg";


const getSessionStorageDetails = () => {
  return JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
};

const FaxViewer = ({
  isOpen,
  hasReadOnly,
  fax = {},
  selectedCoveredEntity,
  toggle,
  hideComments = false,
  refreshComments,
  forwardFax = false,
  togglePdfModal,
}) => {
  const {
    faxID,
    coveredEntityID,
    canMap,
    canMapOthers,
    canDelete,
    patientName,
    providerName,
    fileRepositoryID,
    authFaxNumber,
    validUpto,
    isSingleFax,
    apiPageCount,
    isPatientAutoApproval,
    approvalExpired,
    isPatientMapped,
    approvalStartDate,
    approvalEndDate
  } = fax;

  let hasDatePopupOpen = false;
  const API = useAxios();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [otherProviders, setOtherProvider] = useState(null);
  const [selectedOtherProviders, setSelectedOtherProviders] = useState([]);
  const [comments, setComments] = useState(fax.comments || '');
  const [isConfirm, setConfirm] = useState(false);
  const { tenantID } = selectedCoveredEntity;
  const [faxError, setFaxError] = useState('');
  const [validateUpto, setValidUpto] = useState(null);
  const [reqProgressAfter, setReqProgressAfter] = useState(true);
  const [isForwardToCE, setForwardToCE] = useState(false);
  const [faxInputNumber, setFaxInputNumber] = useState('');
  const [updateFaxNumber, setUpdateFaxNumber] = useState(false);
  const [access_token_key, setAccessTokenKey] = useState('');
  const [isSingle, setIsSingle] = useState(true);
  const [splitPage, SetSplitPage] = useState('');
  const [disabledRadio, SetDisabledRadio] = useState(false);
  const [isOpenSmartApproval, setIsOpenSmartApproval] = useState(false);
  const [mappedData, setMappedData] = useState({});
  const [IsAutoApprove, setIsAutoApprove] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [hasAutoApproveReadOnly, setHasAutoApproveReadOnly] = useState(false);
  const [patientAutoApproval, setPatientAutoApproval] = useState(null);
  const [minDate, setMinDate] = useState(null);
  const [hasfilterChanged, setHasFilterChanged] = useState(Math.random());
  // const {
  //   states: {
  //     userDetails: { access_token },
  //   },
  // } = useContext(AppContext);

  useEffect(() => {
    setPatientAutoApproval(isPatientAutoApproval);
    setIsAutoApprove(isPatientMapped);

    if (isPatientMapped) {
      setHasAutoApproveReadOnly(true);
    }

    if (approvalStartDate !== null) {
      setStartDate(dateFormate(approvalStartDate));
    }
    else {
      setStartDate(null);
    }
    if (approvalEndDate !== null) {
      setEndDate(dateFormate(approvalEndDate));
    } else {
      setEndDate(null);
    }
    setIsSingle(isSingleFax);
    SetDisabledRadio(!isSingleFax ? true : false);
    setLoading(true);
    const { access_token } = getSessionStorageDetails();
    setAccessTokenKey(access_token);
    setSelectedPatient(null);
    setSelectedProvider(null);
    setOtherProvider(null);
    setComments(fax.comments || '');
    getOtherProividers();
    setFaxInputNumber(authFaxNumber);
    setUpdateFaxNumber(false);
    SetSplitPage('');
    setMappedData({});
    if (validUpto != null) {
      setValidUpto(dateFormate(validUpto));
      setReqProgressAfter(false);
    }
    else {
      setValidUpto(null);
      setReqProgressAfter(true)
    }

    let now = moment(new Date()).add(-6, 'M');
    setMinDate(now);

  }, [isOpen]);


  useEffect(() => {
    checkForAutoApproval();
  }, [hasfilterChanged])

  const getOtherProividers = async () => {
    if (!faxID) return;
    try {
      const { data } = await API.get(
        `/${tenantID}/Fax/OtherProviders/${faxID}`,
        {
          hideLoader: true,
        }
      );
      setSelectedOtherProviders(data);
    } catch (error) {
      console.log('errpr ====>> ', error);
    }
  };

  const onLoad = () => {
    setLoading(false);
  };

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
    setHasFilterChanged(Math.random());
  };

  const handleSelectProvider = (provider) => {
    setSelectedProvider(provider);
    setHasFilterChanged(Math.random());
  };

  const handleOtherProvider = (provider) => {
    setOtherProvider(provider);
    setHasFilterChanged(Math.random());
  };

  const checkForAutoApproval = async () => {
    let payload = {};
    payload.faxDetailID = faxID;
    payload.OtherProviderIDs = otherProviders && otherProviders.length
      ? otherProviders.map((provider) => provider.id)
      : [];

    if (selectedPatient) payload.patientId = selectedPatient.id;
    if (selectedProvider) payload.OtherProviderIDs.push(selectedProvider.id);

    if (payload.OtherProviderIDs.length > 0 && (payload.patientId)) {
      let result = await API.post(`/${tenantID}/Fax/patientmapdata/${coveredEntityID}`, payload, {
        hideLoader: true,
      });
      if (result) {
        let data = result.data;
        setIsAutoApprove(data.isPatientMapped);
        setPatientAutoApproval(data.isPatientAutoApproval);
        if (data.isPatientMapped) {
          setHasAutoApproveReadOnly(true);
        }
        else {
          setHasAutoApproveReadOnly(false);
        }
        if (data.approvalStartDate !== null) {
          setStartDate(dateFormate(data.approvalStartDate));
        }
        else {
          setStartDate(null);
        }
        if (data.approvalEndDate !== null) {
          setEndDate(dateFormate(data.approvalEndDate));
        } else {
          setEndDate(null);
        }
        setIsAutoApprove(data.isPatientMapped);
      }
    }
    else if (isPatientMapped) {
      setHasAutoApproveReadOnly(true);
      if (approvalStartDate !== null) {
        setStartDate(dateFormate(approvalStartDate));
      }
      else {
        setStartDate(null);
      }
      if (approvalEndDate !== null) {
        setEndDate(dateFormate(approvalEndDate));
      } else {
        setEndDate(null);
      }
    }
    else {
      setIsAutoApprove(false);
      setHasAutoApproveReadOnly(false);
      setStartDate(null);
      setEndDate(null);
    }
  }

  const handleComment = ({ target: { value } }) => {
    setComments(value);
  };

  const handleDeleteConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const handleCommentSave = async () => {
    setSubmitting(true);
    const payload = {
      faxDetailID: faxID,
      comments: comments,
    }
    payload.CoveredEntityID = coveredEntityID;

    try {
      let result = await API.post(`/${tenantID}/Fax/FaxComment`, payload, {
        hideLoader: true,
      });

      if (result) {
        let data = result.data;
        if (data.error) {
          toast.error(data.message);
          setSubmitting(false);
        }
        else {
          toast.success(data.message);
          setSubmitting(false);
          toggle(false, true);
        }
      }

      let param = {};
      param.CoveredEntityId = coveredEntityID;
      param.ActionType = "FaxToBeMapped";
      const { data } = await API.post(
        `Dashboard/${tenantID}/Taskboard/updatetaskboard`,
        param
      );

    } catch (error) {
      setSubmitting(false);
      console.log('errpr ====>> ', error);
    }
  };

  const handleMap = async () => {
    setSubmitting(true);
    const payload = {
      faxDetailID: faxID,
      comments: comments,
      otherProviderIds:
        otherProviders && otherProviders.length
          ? otherProviders.map((provider) => provider.id)
          : []
    };
    if (selectedPatient) payload.patientId = selectedPatient.id;
    if (selectedProvider) payload.providerId = selectedProvider.id;
    if (fax.patientID) payload.patientId = fax.patientID;
    if (fax.referralProviderID) payload.providerId = fax.referralProviderID;

    payload.validUpto = (!reqProgressAfter) ? validateUpto : null;
    payload.CoveredEntityID = coveredEntityID;
    payload.isSingleFax = isSingle;
    payload.splitPages = splitPage;
    if (!isSingle && splitPage.length == 0) {
      toast.error("Please enter page numbers");
      setSubmitting(false);
      return;
    }
    else if (!isSingle && splitPage.length > 0) {
      let regx = new RegExp('^(\\d-\\d|\\d|\\d-\\d,|\\d,)+$');
      var isValidExp = regx.test(splitPage);
      if (!isValidExp) {
        toast.error("Please enter valid split pattern");
        setSubmitting(false);
        return;
      }
      else {
        var pageNum = splitPage.match(/\d+/g);
        var intArray = pageNum.map(Number);;
        var maxPage = Math.max.apply(null, intArray);
        if (maxPage > apiPageCount) {
          toast.error("Please enter valid page numbers");
          setSubmitting(false);
          return;
        }
      }
    }
    payload.isAutoApprove = IsAutoApprove;
    payload.startDate = startDate;
    payload.endDate = endDate;
    try {
      let result = await API.post(`/${tenantID}/Fax/MapFax`, payload, {
        hideLoader: true,
      });

      if (result) {
        if (isSingle) {
          setMappedData(payload);
          setIsOpenSmartApproval(!isOpenSmartApproval);
        }

        let data = result.data;
        if (data.error) {
          toast.error(result.data.message);
          setSubmitting(false);
        }
        else {
          toast.success('Mapped successfully');
          setSubmitting(false);
          if (!isSingle) {
            toggle(true);
          }
        }
      }

    } catch (error) {
      setSubmitting(false);
      console.log('errpr ====>> ', error);
    }
  };

  const handleDeleteMap = async () => {
    handleDeleteConfirmation();
    setSubmitting(true);
    try {
      await API.delete(`/${tenantID}/Fax/Delete/${faxID}`, {
        hideLoader: true,
      });
      toast.success('Deleted successfully');
      setSubmitting(false);
      handleDeleteConfirmation();
      toggle(true);
    } catch (error) {
      setSubmitting(false);
      console.log('errpr ====>> ', error);
    }
  };

  let disabled = (selectedPatient && selectedProvider) ? false : true;

  if (!canMap) {
    disabled = (otherProviders && otherProviders.length) ? false : true;
  }
  const renderButtons = (disabled, showSmartApp) => {
    if (hasReadOnly) return null;
    return (
      <div className='d-flex'>
        <div
        // color='none'
        // className='ms-3'

        // variant='outline-danger'
        >
          <Button
            className="ms-3 delete-hover"
            onClick={handleDeleteConfirmation}
            // disabled={submitting || disabled}
             disabled={submitting || !canDelete}
            // onClick={handleDeleteConfirmation}
            // disabled={submitting || !canDelete}
            variant="outline-danger"
          >
            <img src={deleteicon} alt="" />
          </Button>{" "}
        </div>

        {
          showSmartApp && <Button
            color='primary'
            className='ms-3 search'
            onClick={handleSmartApp}
          >
            Smart App
          </Button>

        }
        <Button
          color='primary'
          className='search ms-3'
          disabled={disabled || submitting}
          onClick={handleMap}
        >
          <span className="right_5">
            <img src={MapiconWhite} alt="" />
          </span>{" "} Map
        </Button>
      </div>
    );
  };

  const handleSmartApp = () => {
    const payload = {
      faxDetailID: faxID,
      comments: comments,
      otherProviderIds:
        otherProviders && otherProviders.length
          ? otherProviders.map((provider) => provider.id)
          : []
    };
    if (selectedPatient) payload.patientId = selectedPatient.id;
    if (selectedProvider) payload.providerId = selectedProvider.id;
    if (fax.patientID) payload.patientId = fax.patientID;
    if (fax.referralProviderID) payload.providerId = fax.referralProviderID;

    payload.validUpto = (!reqProgressAfter) ? validateUpto : null;
    payload.CoveredEntityID = coveredEntityID;
    payload.isSingleFax = isSingle;
    payload.splitPages = splitPage;
    setMappedData(payload);
    setIsOpenSmartApproval(!isOpenSmartApproval);
  };

  const renderOtherProviderList = () => {
    if (!hasReadOnly) {
      return (
        <NPIProviderList
          tenantID={tenantID}
          onSelect={handleOtherProvider}
          selectedProvider={otherProviders}
          isMulti={true}
        />
      );
    }
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleValidUpto = (startDate) => {
    let stDate = moment(new Date(startDate)).format(
      'MM/DD/YYYY'
    );
    setValidUpto(stDate);
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };


  const handleRequestProgressAfter = () => {
    setReqProgressAfter(!reqProgressAfter);
    return !reqProgressAfter;
  }

  const handleForwardToCE = () => {
    setForwardToCE(!isForwardToCE);
    return !isForwardToCE;
  }

  const setFaxNumber = (val) => {
    setFaxInputNumber(val);
  }

  const handleUpdateFaxNumber = (e) => {
    setUpdateFaxNumber(e.target.checked);
  }


  const handleRadioChange = (val) => {
    if (val === "Single") {
      setIsSingle(true);
      SetSplitPage('');
    }
    else {
      setIsSingle(false);
    }
  }

  const handleSplitPage = (e) => {
    let pageExpression = e.target.value;
    SetSplitPage(pageExpression);
  }

  const editSmartApproval = () => {
    setIsOpenSmartApproval(!isOpenSmartApproval);
    toggle(true);
  };


  const toggleSmartApproval = () => {
    setIsOpenSmartApproval(!isOpenSmartApproval);
    toggle(true);
  }

  const handleAutoApprove = () => {
    setIsAutoApprove(!IsAutoApprove);
    if (!IsAutoApprove) {
      setStartDate(null);
      setEndDate(null);
    }
  }

  const handleStartDate = (startDate) => {
    var edDate = moment(startDate).add(approvalExpired, 'M');
    let stDate = moment(new Date(startDate)).format(
      'MM/DD/YYYY'
    );
    setStartDate(stDate);

    let edDateStr = moment(new Date(edDate)).format(
      'MM/DD/YYYY'
    );
    setEndDate(edDateStr);
  };




  const renderMappingOptions = () => {
    if (loading) return null;

    if (!canMap && !canMapOthers || forwardFax == (true)) {
      return (
        <div>
          {/* <Card className='shadow-top'>
            <CardBody>
              <Row>
                <Col>
                  <FormGroup>
                    <p className='f-14 mb-0'>
                      Patient:

                      <b className='d-block font-weight-500'>
                        {`${patientName || '-'} `}
                      </b>
                    </p>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <p className='f-14 mb-0'>
                      Provider Name:

                      <b className='d-block font-weight-500'>
                        {`${providerName || '-'} `}
                      </b>
                    </p>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card> */}

          <Row>
            <Col md={12}>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Patient:
                  <br />
                  <b className='d-inline-block font-weight-500'>
                    {`${patientName || '-'} `}
                  </b>
                </p>

              </FormGroup>
            </Col>
          </Row>

          <Col md={12}>
            <FormGroup>
              <p className='f-14 mb-0'>
                Provider Name:
                <br />
                <b className='d-inline-block font-weight-500'>
                  {`${providerName || '-'} `}
                </b>
              </p>
            </FormGroup>
          </Col>






        </div>

      );
    } else if (!canMap && canMapOthers) {
      return (
        <>
          <div>
            <Row hidden={hideComments}>
              <Col md={12}>
                <FormGroup>
                  <Label>Comment</Label>
                  <Input
                    type='textarea'
                    value={comments}
                    onChange={handleComment}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row hidden={hideComments}>
              <Col>
                <div className='d-flex justify-content-end align-items-center'>
                  <Button
                    color='primary'
                    className='ms-3 search'
                    onClick={handleCommentSave}
                  >
                    <span className="right_5">
                      <img src={save} alt="" />
                    </span>{" "} Save
                  </Button>
                </div>
              </Col>
            </Row>
            <Row hidden={hideComments}>
              <Col>
                <hr
                  style={{
                    color: "black",
                    backgroundColor: "black",
                    height: 2
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <p className='f-14 mb-0'>
                    Patient:
                    <br />
                    <b className='d-inline-block font-weight-500'>
                      {`${patientName || '-'} `}
                    </b>
                  </p>

                </FormGroup>
              </Col>
            </Row>

            <Col md={12}>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Provider Name:
                  <br />
                  <b className='d-inline-block font-weight-500'>
                    {`${providerName || '-'} `}
                  </b>
                </p>
              </FormGroup>
            </Col>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Other Providers:</Label>
                  {selectedOtherProviders &&
                    selectedOtherProviders.length > 0 &&
                    selectedOtherProviders.map((provider, index) => {
                      return (
                        <b className='d-inline-block font-weight-500'>
                          {`${provider.providerFirstName} ${provider.providerLastName} (${provider.providerNPI})`}
                        </b>
                      );
                    })}
                  <br />
                  {renderOtherProviderList()}
                </FormGroup>
              </Col>
            </Row>
            <Row hidden={hasReadOnly}>
              <Col md={12}>
                <FormGroup>
                  <input className='me-2 form-check-input' type="checkbox" defaultChecked={!reqProgressAfter} onChange={handleRequestProgressAfter} />&nbsp;
                  <Label>Consult Note - Future Request</Label>
                </FormGroup>
              </Col>
            </Row>
            <Row hidden={reqProgressAfter || hasReadOnly}>
              <Col md={12}>
                <FormGroup>
                  <Label>Current Note Effective Through</Label>
                  <InputGroup onMouseLeave={handleMouseLeave}>
                    <Field
                      type='text'
                      id='validateUpto'
                      name='validateUpto'
                      autoComplete='off'
                      placeholder='Select a date'
                      value={validateUpto}
                      component={FormikDatePicker}
                      onChange={handleValidUpto}
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                    <InputGroupText
                      onClick={() => handleDateClick('validateUpto')}
                    >
                      <img src={Calendar} alt='' />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            {/* <Row hidden={!patientAutoApproval}>
              <Col md={12}>
                <FormGroup>
                  <input className='me-2 form-check-input' type="checkbox" defaultChecked={IsAutoApprove} onChange={handleAutoApprove} disabled={hasAutoApproveReadOnly} />&nbsp;
                  <Label>Auto-Approve Prov. & Pt. Combo</Label>
                </FormGroup>
              </Col>
            </Row> */}
            {/* <Row hidden={!IsAutoApprove}>
              <Col md={6}>
                <FormGroup>
                  <Label>Effective Date</Label>
                  <InputGroup onMouseLeave={handleMouseLeave}>
                    <Field
                      type='text'
                      id='startDate'
                      name='startDate'
                      autoComplete='off'
                      placeholder='Select a date'
                      value={startDate}
                      component={FormikDatePicker}
                      onChange={handleStartDate}
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                      readOnly={hasAutoApproveReadOnly}
                    />
                    <InputGroupText
                      onClick={() => handleDateClick('startDate')}
                    >
                      <img src={Calendar} alt='' />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Term Date</Label>
                  <InputGroup onMouseLeave={handleMouseLeave}>
                    <Field
                      type='text'
                      id='endDate'
                      name='endDate'
                      autoComplete='off'
                      placeholder='Select a date'
                      value={endDate}
                      component={FormikDatePicker}
                      readOnly={true}
                    />
                    <InputGroupText>
                      <img src={Calendar} alt='' />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row> */}
            <div className='d-flex justify-content-end align-items-center mt-3'>
              {renderButtons(disabled, true)}
            </div>
          </div>
        </>
      );
    }
    return (
      <>
        <div>
          <Row hidden={hideComments}>
            <Col md={12}>
              <FormGroup>
                <Label>Comment</Label>
                <Input
                  type='textarea'
                  value={comments}
                  onChange={handleComment}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row hidden={hideComments}>
            <Col>
              <div className='d-flex justify-content-end align-items-center'>
                <Button
                  color='primary'
                  className='ms-3 search'
                  onClick={handleCommentSave}
                >
                  <span className="right_5">
                    <img src={save} alt="" />
                  </span>{" "}Save
                </Button>
              </div>
            </Col>
          </Row>
          <Row hidden={hideComments}>
            <Col>
              <hr
                style={{
                  color: "black",
                  backgroundColor: "black",
                  height: 2
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <FormGroup>
                <Input
                  name="radio2"
                  type="radio"
                  onChange={() => handleRadioChange('Single')}
                  checked={isSingle}
                  disabled={disabledRadio}
                />
                {' '}
                <Label check>
                  Single
                </Label>
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <Input
                  name="radio2"
                  type="radio"
                  onChange={() => handleRadioChange('Split')}
                  checked={!isSingle}
                  disabled={disabledRadio}
                />
                {' '}
                <Label check>
                  Split
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row hidden={isSingle}>
            <Col>
              <FormGroup>
                <input id="splitPage" name="splitPage" value={splitPage} className="form-control" type="text" placeholder='e.g. 1-5,8,11-13' onChange={handleSplitPage} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for='patientID'>Patient</Label>
                <PatientList
                  tenantID={tenantID}
                  onSelect={handleSelectPatient}
                  selectedPatient={selectedPatient}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>NPI/Provider Name</Label>
                <NPIProviderList
                  tenantID={tenantID}
                  onSelect={handleSelectProvider}
                  selectedProvider={selectedProvider}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Other Providers</Label>
                {renderOtherProviderList()}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <input className='me-2 form-check-input' type="checkbox" defaultChecked={!reqProgressAfter} onChange={handleRequestProgressAfter} />&nbsp;
                <Label>Consult Note - Future Renewal</Label>
              </FormGroup>
            </Col>
          </Row>
          <Row hidden={reqProgressAfter}>
            <Col md={12}>
              <FormGroup>
                <Label>Current Note Effective Through</Label>
                <InputGroup onMouseLeave={handleMouseLeave}>
                  <Field
                    type='text'
                    id='validateUpto'
                    name='validateUpto'
                    autoComplete='off'
                    placeholder='Select a date'
                    value={validateUpto}
                    component={FormikDatePicker}
                    onChange={handleValidUpto}
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                  <InputGroupText
                    onClick={() => handleDateClick('validateUpto')}
                  >
                    <img src={Calendar} alt='' />
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          {/* <Row hidden={!patientAutoApproval}>
            <Col md={12}>
              <FormGroup>
                <input className='me-2 form-check-input' type="checkbox" defaultChecked={IsAutoApprove} onChange={handleAutoApprove} checked={IsAutoApprove} disabled={hasAutoApproveReadOnly} />&nbsp;
                <Label>Auto-Approve Prov. & Pt. Combo</Label>
              </FormGroup>
            </Col>
          </Row> */}
          <Row hidden={!IsAutoApprove}>
            <Col md={6}>
              <FormGroup>
                <Label>Effective Date</Label>
                <InputGroup onMouseLeave={handleMouseLeave}>
                  <Field
                    type='text'
                    id='startDate'
                    name='startDate'
                    autoComplete='off'
                    placeholder='Select a date'
                    value={startDate}
                    component={FormikDatePicker}
                    onChange={handleStartDate}
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    readOnly={hasAutoApproveReadOnly}
                    minDate={new Date(minDate)}
                  />
                  <InputGroupText
                    onClick={() => handleDateClick('startDate')}
                  >
                    <img src={Calendar} alt='' />
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Term Date</Label>
                <InputGroup onMouseLeave={handleMouseLeave}>
                  <Field
                    type='text'
                    id='endDate'
                    name='endDate'
                    autoComplete='off'
                    placeholder='Select a date'
                    value={endDate}
                    component={FormikDatePicker}
                    readOnly={true}
                  />
                  <InputGroupText>
                    <img src={Calendar} alt='' />
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <div className='d-flex justify-content-end align-items-center mt-4'>
            {renderButtons(disabled, false)}
          </div>
        </div>
      </>
    );
  };

  const renderLoader = () => {
    if (loading || submitting) return <Loader />;
    return null;
  };

  return (
    <div>
      <div
      // isOpen={isOpen} toggle={toggle} size='xl' className='xxl'
      >
        {/* <div toggle={toggle}>Fax View</div> */}
        <div>
          {renderLoader()}
          <Row className='mb-2'>
            <Col md={9}
            // sm={(!canMap && !canMapOthers || forwardFax == (true)) ? 8 : 8}
            >
              <iframe
                className='w-100 view-container'
                src={`${process.env.REACT_APP_ENDPOINT}/RCM/${tenantID}/fax/viewfax/${faxID}/${forwardFax}/${fileRepositoryID}?access_token=${access_token_key}`}
                height='600'
                onLoad={onLoad}
              />
            </Col>
            <Col md={3} style={{ paddingLeft: "1rem", }}>
              <Formik enableReinitialize={true} children={(props) => renderMappingOptions()}>

              </Formik>
            </Col>

            {/* <Formik enableReinitialize={true} children={(props) => renderMappingOptions()}>

            </Formik> */}

          </Row>
        </div>
      </div>
      <Confirm
        isOpen={isConfirm}
        loading={submitting}
        message='Are you sure you want to delete?'
        onToggle={handleDeleteConfirmation}
        onCancel={handleDeleteConfirmation}
        onContinue={handleDeleteMap}
      />


      <Modal
        isOpen={isOpenSmartApproval}
        toggle={editSmartApproval}
        size='xl'
        className='xl'
      >
        <ModalHeader toggle={editSmartApproval}>
          Smart Approval
        </ModalHeader>
        <ModalBody>
          <SmartApproval mappedData={mappedData} tenantID={tenantID} toggle={toggleSmartApproval} togglePdfModal={togglePdfModal} />
        </ModalBody>
      </Modal>


    </div>
  );
};

export default FaxViewer;
